import React from 'react'
import { Panel } from 'rsuite'
import { useSelector } from 'react-redux'
import NoTopicsMessage from '@/components/overview/noTopicsMessage'
import PublicationTopicRow from '@/components/themes/subaru/publications/publicationTopicRow'
import { useVisualTopicSelector } from '@/components/visualTopicSelector'
import { searchSelectors } from '@/store/search'
import SearchTopicRow from './searchTopicRow'
import styles from './visualTopics.module.scss'

const NordicsTopics = () => {
  const { filterBy } = useSelector(searchSelectors.selectQuery)
  const {
    hotspotForCurrentView,
    partTopics,
    onTopicSelect,
    onTabChange,
    publicationRowClassName,
    publicationListClassName
  } = useVisualTopicSelector()

  if (!hotspotForCurrentView?.photo) {
    return <NoTopicsMessage onLinkClick={() => onTabChange('manuals')} />
  }

  return (
    <div className={styles.visualTopics}>
      <Panel className={publicationListClassName}>
        {partTopics?.map(topic => (
          <PublicationTopicRow
            key={topic.id}
            type={topic.type}
            title={topic.title}
            onClick={() => onTopicSelect(topic)}
            className={publicationRowClassName}
          />
        ))}
      </Panel>
      <Panel className={publicationListClassName}>
        <SearchTopicRow
          brand={filterBy?.brand}
          model={filterBy?.model}
          modelType={filterBy?.modelType}
          year={filterBy?.year}
          language={filterBy?.language}
          className={publicationRowClassName}
        />
      </Panel>
    </div>
  )
}

export default NordicsTopics
